import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
export var MessageTimestamp = /*#__PURE__*/function (_ValueObject) {
  _inherits(MessageTimestamp, _ValueObject);

  var _super = _createSuper(MessageTimestamp);

  function MessageTimestamp() {
    _classCallCheck(this, MessageTimestamp);

    return _super.apply(this, arguments);
  }

  _createClass(MessageTimestamp, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }, {
    key: "toReadableDate",
    value: function toReadableDate() {
      return this.value.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    }
  }], [{
    key: "create",
    value: function create(unixTimestamp) {
      if (!unixTimestamp) {
        return Result.fail('Created time is required');
      }

      return Result.ok(new MessageTimestamp(new Date(+unixTimestamp)));
    }
  }, {
    key: "now",
    value: function now() {
      return new MessageTimestamp(new Date());
    }
  }]);

  return MessageTimestamp;
}(ValueObject);